export const ADD = 'entities/role/ADD';
export const ADD_MULTIPLE = 'entities/role/ADD_MULTIPLE';
export const UPDATE = 'entities/role/UPDATE';
export const REMOVE = 'entities/role/REMOVE';
